module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "el-zoom-in-top"
    }
  }, [_c('div', {
    staticClass: "content-wrapper"
  }, [_c('section', {
    staticClass: "content-header"
  }, [_c('ol', {
    staticClass: "breadcrumb"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [_c('i', {
    staticClass: "ti-home"
  })])], 1), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/toko"
    }
  }, [_vm._v("TOKO")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#/toko_dashboard"
    }
  }, [_vm._v("DASHBOARD")])])])]), _vm._v(" "), _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-header with-border"
  }, [_c('div', {
    staticClass: "pull-left",
    staticStyle: {
      "padding-left": "20px",
      "padding-top": "10px"
    }
  }, [_vm._v("\n                          DASHBOARD\n                          "), _c('h4', [(this.data) ? _c('b', [_vm._v(_vm._s(this.nama_toko) + " (" + _vm._s(this.tahun) + ")")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "pull-right",
    staticStyle: {
      "padding-right": "20px",
      "padding-top": "5px"
    }
  }, [_c('el-button', {
    directives: [{
      name: "loading",
      rawName: "v-loading.fullscreen.lock",
      value: (_vm.fullscreenLoading),
      expression: "fullscreenLoading",
      modifiers: {
        "fullscreen": true,
        "lock": true
      }
    }],
    attrs: {
      "icon": "el-icon-search",
      "circle": ""
    },
    on: {
      "click": function($event) {
        return _vm.filterData()
      }
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('el-row', [_c('el-col', {
    staticStyle: {
      "padding": "5px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('div', {
    staticClass: "box palette-Indigo-900 bg"
  }, [_c('div', {
    staticClass: "box-header  palette-Indigo-900 bg"
  }, [_c('div', {
    staticClass: "pull-right text-white box-tools"
  }, [_c('span', {
    staticClass: "text-white box-btn"
  }, [_c('i', {
    staticClass: "circle-nest-medium dripicons-cart"
  })]), _vm._v("   \n                                  ")]), _vm._v(" "), _c('h3', {
    staticClass: "box-title"
  }, [_c('span', {
    staticClass: "text-white"
  }, [_vm._v("   SALES")])])]), _vm._v(" "), _c('div', {
    staticClass: "box-body no-pad",
    staticStyle: {
      "display": "block",
      "padding": "0px !important"
    }
  }, [_c('div', {
    staticClass: "events-nest"
  }, [_c('div', {
    staticClass: "wrap-no-pad text-white"
  }, [_c('h2', {
    staticClass: "text-white",
    staticStyle: {
      "color": "white",
      "word-break": "break-all"
    }
  }, [(_vm.data.sales_all) ? _c('strong', [_vm._v(_vm._s(_vm.data.sales_all.replace(/\.00$/, '') + ' (' + _vm.data.total_days + ' Hari)'))]) : _vm._e()]), _vm._v(" "), _c('br')])])])])]), _vm._v(" "), _c('el-col', {
    staticStyle: {
      "padding": "5px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('div', {
    staticClass: "box palette-Indigo-900 bg"
  }, [_c('div', {
    staticClass: "box-header  palette-Indigo-900 bg"
  }, [_c('div', {
    staticClass: "pull-right text-white box-tools"
  }, [_c('span', {
    staticClass: "text-white box-btn"
  }, [_c('i', {
    staticClass: "circle-nest-medium dripicons-graph-line"
  })]), _vm._v("   \n                                  ")]), _vm._v(" "), _c('h3', {
    staticClass: "box-title"
  }, [_c('span', {
    staticClass: "text-white"
  }, [_vm._v("   SALES AVG")])])]), _vm._v(" "), _c('div', {
    staticClass: "box-body no-pad",
    staticStyle: {
      "display": "block",
      "padding": "0px !important"
    }
  }, [_c('div', {
    staticClass: "events-nest"
  }, [_c('div', {
    staticClass: "wrap-no-pad text-white"
  }, [_c('h2', {
    staticClass: "text-white",
    staticStyle: {
      "color": "white",
      "word-break": "break-all"
    }
  }, [(_vm.data.sales_avg) ? _c('strong', [_vm._v(_vm._s(_vm.data.sales_avg.replace(/\.00$/, '')))]) : _vm._e()]), _vm._v(" "), _c('br')])])])])])], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    staticStyle: {
      "padding": "5px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('div', {
    staticClass: "box palette-Teal-900 bg"
  }, [_c('div', {
    staticClass: "box-header  palette-Teal-900 bg"
  }, [_c('div', {
    staticClass: "pull-right text-white box-tools"
  }, [_c('span', {
    staticClass: "text-white box-btn"
  }, [_c('i', {
    staticClass: "circle-nest-medium dripicons-basket"
  })]), _vm._v("   \n                                  ")]), _vm._v(" "), _c('h3', {
    staticClass: "box-title"
  }, [_c('span', {
    staticClass: "text-white"
  }, [_vm._v("   COGS BULANAN")])])]), _vm._v(" "), _c('div', {
    staticClass: "box-body no-pad",
    staticStyle: {
      "display": "block",
      "padding": "0px !important"
    }
  }, [_c('div', {
    staticClass: "events-nest"
  }, [_c('div', {
    staticClass: "wrap-no-pad text-white"
  }, [_c('h2', {
    staticClass: "text-white",
    staticStyle: {
      "color": "white",
      "word-break": "break-all"
    }
  }, [(_vm.data.cogs_bulanan) ? _c('strong', [_vm._v(_vm._s(_vm.data.cogs_bulanan.replace(/\.00$/, '') + ' (' + parseFloat((parseFloat(_vm.data.cogs_bulanan.replace(/,/g, '')) / parseFloat(_vm.data.sales_all.replace(/,/g, ''))) * 100).toFixed(2).replace(/\.00$/, '') + '%)'))]) : _vm._e()]), _vm._v(" "), _c('br')])])])])]), _vm._v(" "), _c('el-col', {
    staticStyle: {
      "padding": "5px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('div', {
    staticClass: "box palette-Teal-900 bg"
  }, [_c('div', {
    staticClass: "box-header palette-Teal-900 bg"
  }, [_c('div', {
    staticClass: "pull-right text-white box-tools"
  }, [_c('span', {
    staticClass: "text-white box-btn"
  }, [_c('i', {
    staticClass: "circle-nest-medium dripicons-basket"
  })]), _vm._v("   \n                                  ")]), _vm._v(" "), _c('h3', {
    staticClass: "box-title"
  }, [_c('span', {
    staticClass: "text-white"
  }, [_vm._v("   COGS HARIAN")])])]), _vm._v(" "), _c('div', {
    staticClass: "box-body no-pad",
    staticStyle: {
      "display": "block",
      "padding": "0px !important"
    }
  }, [_c('div', {
    staticClass: "events-nest"
  }, [_c('div', {
    staticClass: "wrap-no-pad text-white"
  }, [_c('h2', {
    staticClass: "text-white",
    staticStyle: {
      "color": "white",
      "word-break": "break-all"
    }
  }, [(_vm.data.cogs_harian) ? _c('strong', [_vm._v(_vm._s(_vm.data.cogs_harian.replace(/\.00$/, '') + ' (' + parseFloat((parseFloat(_vm.data.cogs_harian.replace(/,/g, '')) / parseFloat(_vm.data.sales_all.replace(/,/g, ''))) * 100).toFixed(2).replace(/\.00$/, '') + '%)'))]) : _vm._e()]), _vm._v(" "), _c('br')])])])])])], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    staticStyle: {
      "padding": "5px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('div', {
    staticClass: "box palette-Cyan-700 bg"
  }, [_c('div', {
    staticClass: "box-header palette-Cyan-700 bg"
  }, [_c('div', {
    staticClass: "pull-right text-white box-tools"
  }, [_c('span', {
    staticClass: "text-white box-btn"
  }, [_c('i', {
    staticClass: "circle-nest-medium dripicons-basket"
  })]), _vm._v("   \n                                  ")]), _vm._v(" "), _c('h3', {
    staticClass: "box-title"
  }, [_c('span', {
    staticClass: "text-white"
  }, [_vm._v("   COST BULANAN")])])]), _vm._v(" "), _c('div', {
    staticClass: "box-body no-pad",
    staticStyle: {
      "display": "block",
      "padding": "0px !important"
    }
  }, [_c('div', {
    staticClass: "events-nest"
  }, [_c('div', {
    staticClass: "wrap-no-pad text-white"
  }, [_c('h2', {
    staticClass: "text-white",
    staticStyle: {
      "color": "white",
      "word-break": "break-all"
    }
  }, [(_vm.data.opr_bulanan) ? _c('strong', [_vm._v(_vm._s(_vm.data.opr_bulanan.replace(/\.00$/, '') + ' (' + parseFloat((parseFloat(_vm.data.opr_bulanan.replace(/,/g, '')) / parseFloat(_vm.data.sales_all.replace(/,/g, ''))) * 100).toFixed(2).replace(/\.00$/, '') + '%)'))]) : _vm._e()]), _vm._v(" "), _c('br')])])])])]), _vm._v(" "), _c('el-col', {
    staticStyle: {
      "padding": "5px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('div', {
    staticClass: "box palette-Cyan-700 bg"
  }, [_c('div', {
    staticClass: "box-header palette-Cyan-700 bg"
  }, [_c('div', {
    staticClass: "pull-right text-white box-tools"
  }, [_c('span', {
    staticClass: "text-white box-btn"
  }, [_c('i', {
    staticClass: "circle-nest-medium dripicons-basket"
  })]), _vm._v("   \n                                  ")]), _vm._v(" "), _c('h3', {
    staticClass: "box-title"
  }, [_c('span', {
    staticClass: "text-white"
  }, [_vm._v("   COST HARIAN")])])]), _vm._v(" "), _c('div', {
    staticClass: "box-body no-pad",
    staticStyle: {
      "display": "block",
      "padding": "0px !important"
    }
  }, [_c('div', {
    staticClass: "events-nest"
  }, [_c('div', {
    staticClass: "wrap-no-pad text-white"
  }, [_c('h2', {
    staticClass: "text-white",
    staticStyle: {
      "color": "white",
      "word-break": "break-all"
    }
  }, [(_vm.data.opr_harian) ? _c('strong', [_vm._v(_vm._s(_vm.data.opr_harian.replace(/\.00$/, '') + ' (' + parseFloat((parseFloat(_vm.data.opr_harian.replace(/,/g, '')) / parseFloat(_vm.data.sales_all.replace(/,/g, ''))) * 100).toFixed(2).replace(/\.00$/, '') + '%)'))]) : _vm._e()]), _vm._v(" "), _c('br')])])])])])], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
    staticStyle: {
      "padding": "5px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('div', {
    staticClass: "box palette-Red-900 bg"
  }, [_c('div', {
    staticClass: "box-header  palette-Red-900 bg"
  }, [_c('div', {
    staticClass: "pull-right text-white box-tools"
  }, [_c('span', {
    staticClass: "text-white box-btn"
  }, [_c('i', {
    staticClass: "circle-nest-medium dripicons-trash"
  })]), _vm._v("   \n                                  ")]), _vm._v(" "), _c('h3', {
    staticClass: "box-title"
  }, [_c('span', {
    staticClass: "text-white"
  }, [_vm._v("   WASTE")])])]), _vm._v(" "), _c('div', {
    staticClass: "box-body no-pad",
    staticStyle: {
      "display": "block",
      "padding": "0px !important"
    }
  }, [_c('div', {
    staticClass: "events-nest"
  }, [_c('div', {
    staticClass: "wrap-no-pad text-white"
  }, [_c('h2', {
    staticClass: "text-white",
    staticStyle: {
      "color": "white",
      "word-break": "break-all"
    }
  }, [(_vm.data.waste) ? _c('strong', [_vm._v(_vm._s(_vm.data.waste.replace(/\.00$/, '') + ' (' + parseFloat((parseFloat(_vm.data.waste.replace(/,/g, '')) / parseFloat(_vm.data.sales_all.replace(/,/g, ''))) * 100).toFixed(2).replace(/\.00$/, '') + '%)'))]) : _vm._e()]), _vm._v(" "), _c('br')])])])])]), _vm._v(" "), _c('el-col', {
    staticStyle: {
      "padding": "5px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('div', {
    staticClass: "box palette-Deep-Orange-900 bg"
  }, [_c('div', {
    staticClass: "box-header  palette-Deep-Orange-900 bg"
  }, [_c('div', {
    staticClass: "pull-right text-white box-tools"
  }, [_c('span', {
    staticClass: "text-white box-btn"
  }, [_c('i', {
    staticClass: "circle-nest-medium dripicons-pulse"
  })]), _vm._v("   \n                                  ")]), _vm._v(" "), _c('h3', {
    staticClass: "box-title"
  }, [_c('span', {
    staticClass: "text-white"
  }, [_vm._v("   NET PROFIT")])])]), _vm._v(" "), _c('div', {
    staticClass: "box-body no-pad",
    staticStyle: {
      "display": "block",
      "padding": "0px !important"
    }
  }, [_c('div', {
    staticClass: "events-nest"
  }, [_c('div', {
    staticClass: "wrap-no-pad text-white"
  }, [_c('h2', {
    staticClass: "text-white",
    staticStyle: {
      "color": "white",
      "word-break": "break-all"
    }
  }, [(_vm.data.sales_all) ? _c('strong', [_vm._v(_vm._s(_vm.toMoney(parseFloat(parseFloat(_vm.data.sales_all.replace(/,/g, '')) - parseFloat(parseFloat(_vm.data.opr_bulanan.replace(/,/g, '')) + parseFloat(_vm.data.opr_harian.replace(/,/g, '')) + parseFloat(_vm.data.cogs_bulanan.replace(/,/g, '')) + parseFloat(_vm.data.cogs_harian.replace(/,/g, ''))))) + ' (' + parseFloat((parseFloat(parseFloat(_vm.data.sales_all.replace(/,/g, '')) - parseFloat(parseFloat(_vm.data.opr_bulanan.replace(/,/g, '')) + parseFloat(_vm.data.opr_harian.replace(/,/g, '')) + parseFloat(_vm.data.cogs_bulanan.replace(/,/g, '')) + parseFloat(_vm.data.cogs_harian.replace(/,/g, '')))) / parseFloat(_vm.data.sales_all.replace(/,/g, ''))) * 100).toFixed(2).replace(/\.00$/, '') + '%)'))]) : _vm._e()]), _vm._v(" "), _c('br')])])])])])], 1), _vm._v(" "), (this.data) ? _c('el-row', [_c('el-col', {
    staticStyle: {
      "padding": "5px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('ve-histogram', {
    attrs: {
      "data": _vm.chartDataHistogram,
      "settings": _vm.chartSettingsHistogram
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (this.data && this.kode_toko.indexOf(',') < 0) ? _c('el-row', [_c('el-col', {
    staticStyle: {
      "padding": "5px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-alert', {
    attrs: {
      "title": "Data didapatkan dari Pegawai yang melakukan ABSENSI di bulan terpilih",
      "type": "info",
      "closable": false
    }
  }), _c('br'), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loadingModal),
      expression: "loadingModal"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "border": "",
      "hover": "",
      "data": _vm.pegawaiData,
      "responsive": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "nama",
      "label": "PEGAWAI"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "level",
      "label": "LEVEL",
      "width": "200px"
    }
  })], 1), _vm._v(" "), _c('br'), _vm._v(" "), _c('el-alert', {
    attrs: {
      "title": "Dihitung dengan rumus :",
      "type": "info",
      "description": "Qty Aktual Terjual / Qty Terjual Menurut Ingredient",
      "closable": false
    }
  }), _c('br'), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loadingModal),
      expression: "loadingModal"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "border": "",
      "hover": "",
      "data": _vm.rasioData,
      "responsive": ""
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "nama",
      "label": "BARANG"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "prosentase",
      "label": "% RASIO",
      "header-align": "center",
      "align": "center",
      "width": "100px"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    staticStyle: {
      "padding": "5px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('ve-pie', {
    staticStyle: {
      "width": "100%",
      "heigth": "100%"
    },
    attrs: {
      "data": _vm.chartData,
      "settings": _vm.chartSettings
    }
  })], 1)], 1) : _vm._e()], 1)]), _vm._v(" "), _c('el-dialog', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loadingModalFilter),
      expression: "loadingModalFilter"
    }],
    attrs: {
      "title": "Filter Data",
      "visible": _vm.dialogFormFilter,
      "close-on-click-modal": false,
      "width": "99%",
      "top": "1%"
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogFormFilter = $event
      }
    }
  }, [_c('el-form', {
    ref: "formFilter",
    staticClass: "demo-ruleForm",
    attrs: {
      "status-icon": "",
      "rules": _vm.rules3,
      "label-width": _vm.formLabelWidth
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
      }
    }
  }, [(this.region.length > 0) ? _c('el-form-item', {
    attrs: {
      "label": "Pilih Region",
      "prop": "region"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "clearable": "",
      "filterable": "",
      "placeholder": "Pilih Region"
    },
    on: {
      "change": _vm.cbPilihRegion
    },
    model: {
      value: (_vm.regionSelected),
      callback: function($$v) {
        _vm.regionSelected = $$v
      },
      expression: "regionSelected"
    }
  }, _vm._l((_vm.region), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item
      }
    })
  }), 1)], 1) : _vm._e(), _vm._v(" "), (this.wilayah.length > 0) ? _c('el-form-item', {
    attrs: {
      "label": "Pilih Wilayah",
      "prop": "wilayah"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "clearable": "",
      "filterable": "",
      "placeholder": "Pilih Wilayah"
    },
    on: {
      "change": _vm.cbPilihWilayah
    },
    model: {
      value: (_vm.wilayahSelected),
      callback: function($$v) {
        _vm.wilayahSelected = $$v
      },
      expression: "wilayahSelected"
    }
  }, _vm._l((_vm.wilayah), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item
      }
    })
  }), 1)], 1) : _vm._e(), _vm._v(" "), (this.area.length > 0) ? _c('el-form-item', {
    attrs: {
      "label": "Pilih Area",
      "prop": "area"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "clearable": "",
      "filterable": "",
      "placeholder": "Pilih Area"
    },
    on: {
      "change": _vm.cbPilihArea
    },
    model: {
      value: (_vm.areaSelected),
      callback: function($$v) {
        _vm.areaSelected = $$v
      },
      expression: "areaSelected"
    }
  }, _vm._l((_vm.area), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item
      }
    })
  }), 1)], 1) : _vm._e(), _vm._v(" "), (this.cabang.length > 0) ? _c('el-form-item', {
    attrs: {
      "label": "Pilih Cabang",
      "prop": "cabang"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "clearable": "",
      "filterable": "",
      "placeholder": "Pilih Cabang"
    },
    on: {
      "change": _vm.cbPilihCabang
    },
    model: {
      value: (_vm.cabangSelected),
      callback: function($$v) {
        _vm.cabangSelected = $$v
      },
      expression: "cabangSelected"
    }
  }, _vm._l((_vm.cabang), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item
      }
    })
  }), 1)], 1) : _vm._e(), _vm._v(" "), (this.toko.length > 0) ? _c('el-form-item', {
    attrs: {
      "label": "Pilih Toko",
      "prop": "toko"
    }
  }, [_c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "clearable": "",
      "filterable": "",
      "placeholder": "Pilih Toko"
    },
    on: {
      "change": _vm.cbPilihToko
    },
    model: {
      value: (_vm.tokoSelected),
      callback: function($$v) {
        _vm.tokoSelected = $$v
      },
      expression: "tokoSelected"
    }
  }, _vm._l((_vm.toko), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item
      }
    })
  }), 1)], 1) : _vm._e(), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "Periode",
      "prop": "tanggal"
    }
  }, [_c('el-date-picker', {
    staticStyle: {
      "width": "120px"
    },
    attrs: {
      "type": "month",
      "placeholder": "Pilih Bulan",
      "align": "right"
    },
    on: {
      "change": _vm.handleChangeDate
    },
    model: {
      value: (_vm.value4),
      callback: function($$v) {
        _vm.value4 = $$v
      },
      expression: "value4"
    }
  })], 1)], 1), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.dialogFormFilter = false
      }
    }
  }, [_vm._v("Batal")]), _vm._v(" "), (this.kode_toko.length > 0) ? _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.getData()
      }
    }
  }, [_vm._v("Tampilkan")]) : _vm._e()], 1)], 1)], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-253f1055!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modules/master_data/TokoDashboard1.vue
// module id = 1354
// module chunks = 2